/* eslint-disable react/prop-types */
import React from 'react';
import get from 'lodash/get';
import { StaticDataContext } from 'context/StaticDataProvider/index';
import GCCFormModal from './GccFormModal/index';

export const GenerateFormContext = React.createContext();

const DEFAULT_STATE = {
  gcc: {
    open: false,
    title: 'Generate GCC',
  },
  cpc: { open: false },
  doc: { open: false },
};

export default ({ productId, product, children, reloadTestData }) => {
  const { getOptions } = React.useContext(StaticDataContext);

  const [modalForm, setModalForm] = React.useState(DEFAULT_STATE);
  const exportMarkets = getOptions('exportMarket');
  const UsMarket = exportMarkets.find((market) => market.countryCode === 'US');
  const EUMarket = exportMarkets.find((market) => market.countryCode === 'EU');

  const openForm = (type, props) => {
    setModalForm((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        ...props,
        open: true,
      },
    }));
  };

  const closeForm = (type) => {
    setModalForm((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        open: false,
      },
    }));
  };

  return (
    <GenerateFormContext.Provider
      value={{
        openForm,
        closeForm,
      }}>
      {children}
      <GCCFormModal
        type="gcc"
        productId={productId}
        product={product}
        modalForm={modalForm.gcc}
        closeForm={closeForm}
        openForm={openForm}
        countryId={get(UsMarket, 'id')}
        onConfirmSuccess={() => {
          reloadTestData();
        }}
      />
      <GCCFormModal
        type="cpc"
        productId={productId}
        product={product}
        modalForm={modalForm.cpc}
        closeForm={closeForm}
        openForm={openForm}
        countryId={get(UsMarket, 'id')}
        onConfirmSuccess={() => {
          reloadTestData();
        }}
      />
      <GCCFormModal
        type="doc"
        productId={productId}
        product={product}
        modalForm={modalForm.doc}
        closeForm={closeForm}
        openForm={openForm}
        countryId={get(EUMarket, 'id')}
        onConfirmSuccess={() => {
          reloadTestData();
        }}
      />
    </GenerateFormContext.Provider>
  );
};
